var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 55,
    viewBox: "0 0 61 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_46_7925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.7343 0L32.9888 18.5781L37.7764 7.62943L58.7343 0Z",
    fill: "#E17726"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.57593 0.0218201L22.4777 7.63076L27.0237 18.723L1.57593 0.0218201Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3735 39.5104L59.7525 39.7216L55.7757 52.897L41.8907 49.1686L48.3735 39.5104Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8764 39.5104L18.3351 49.1687L4.47339 52.8972L0.520752 39.7216L11.8764 39.5104Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4056 15.8975L26.8708 30.5452L12.9557 29.9278L16.9137 24.1043L16.9638 24.0482L26.4056 15.8975Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7002 15.7342L43.2861 24.0488L43.3357 24.1045L47.2938 29.9279L33.382 30.5452L33.7002 15.7342Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7426 39.5529L26.3406 45.3264L17.5145 49.4822L18.7426 39.5529Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5088 39.552L42.7114 49.4822L33.91 45.326L41.5088 39.552Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1042 44.7821L43.0356 48.9996L34.7277 52.8503L34.8139 50.3053L34.1042 44.7821Z",
    fill: "#D5BFB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1433 44.784L25.4614 50.2637L25.5174 52.8474L17.1899 48.9997L26.1433 44.784Z",
    fill: "#D5BFB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5641 32.4569L25.8981 37.2404L17.9519 34.9703L23.5641 32.4569Z",
    fill: "#233447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6855 32.4574L42.3241 34.9702L34.3522 37.2397L36.6855 32.4574Z",
    fill: "#233447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3499 39.5041L18.0654 49.7989L11.1812 39.7291L19.3499 39.5041Z",
    fill: "#CC6228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9006 39.5041L49.0696 39.7292L42.1594 49.7992L40.9006 39.5041Z",
    fill: "#CC6228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.495 29.3457L41.55 35.2545L36.9665 33.2117L34.7719 37.7109L33.3333 29.974L47.495 29.3457Z",
    fill: "#CC6228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7521 29.3456L26.9163 29.974L25.4777 37.7109L23.2827 33.2123L18.7233 35.2546L12.7521 29.3456Z",
    fill: "#CC6228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3513 28.1331L19.0775 34.7894L19.3106 41.3605L12.3513 28.1331Z",
    fill: "#E27525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9055 28.1211L40.9338 41.3721L41.1963 34.7892L47.9055 28.1211Z",
    fill: "#E27525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5876 28.5385L26.8582 30.2002L27.5272 34.3398L27.0971 47.0542L25.0639 36.8406L25.0632 36.735L26.5876 28.5385Z",
    fill: "#E27525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6588 28.5155L35.1872 36.735L35.1865 36.8406L33.1482 47.0797L33.0676 44.5187L32.7495 34.2645L33.6588 28.5155Z",
    fill: "#E27525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7942 34.5248L41.5666 40.234L34.4711 45.6254L33.0367 44.637L34.6446 36.5604L41.7942 34.5248Z",
    fill: "#F5841F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4805 34.5249L25.6054 36.5606L27.2132 44.6371L25.7788 45.6254L18.683 40.2336L18.4805 34.5249Z",
    fill: "#F5841F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8324 47.7389L24.9102 51.9336L24.8718 50.1424L25.6313 49.4922H34.6158L35.4029 50.1402L35.3449 51.9302L44.3651 47.7495L39.9759 51.2868L34.6683 54.8419H25.5586L20.2545 51.2722L15.8324 47.7389Z",
    fill: "#C0AC9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.454 44.2238L34.7375 45.108L35.4896 50.9606L34.4011 50.0642H25.8522L24.7844 50.9786L25.5119 45.1085L26.7958 44.2238H33.454Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0346 0.514252L60.125 9.55596L58.195 18.698L59.5693 19.732L57.7096 21.1157L59.1073 22.1684L57.2565 23.8122L58.3928 24.6146L55.3774 28.0491L43.0094 24.5372L42.9022 24.4812L33.9896 17.149L57.0346 0.514252Z",
    fill: "#763E1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.21547 0.514252L26.2605 17.149L17.3479 24.4812L17.2407 24.5372L4.87267 28.0491L1.85732 24.6146L2.99264 23.8128L1.14278 22.1684L2.53779 21.1169L0.650313 19.7292L2.07648 18.6946L0.125 9.5563L3.21547 0.514252Z",
    fill: "#763E1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4043 23.7692L55.5089 27.4901L59.7665 40.2868L48.5343 40.2868L40.795 40.382L46.4234 29.683L42.4043 23.7692Z",
    fill: "#F5841F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8457 23.7692L13.8259 29.683L19.4549 40.382L11.7194 40.2868H0.507202L4.7408 27.4902L17.8457 23.7692Z",
    fill: "#F5841F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4181 7.56839L34.7527 17.223L33.9748 30.2654L33.6772 34.3534L33.6536 44.7962H26.5962L26.5733 34.3729L26.2747 30.2618L25.4965 17.223L21.8317 7.56839H38.4181Z",
    fill: "#F5841F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_46_7925"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 54.8571,
    fill: "white",
    transform: "translate(0.125)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.b632e8c227aa08feb1df123fea60af53.svg";
export { ForwardRef as ReactComponent };